import { IXmlNode } from '@/app-modules/server-communications';
import { IPrizeStructure } from '@/components/game/implementations/_default/_domain/models';
import { CatchUpData, ResetData, CallsData, NextGameData, PrizeData, BoxNumbersData } from '@/components/game/_domain/server';

class DefaultPrizeData extends PrizeData {
  constructor(node: IXmlNode) {
    super(node);
  }

  protected getPrizeStructure(node: IXmlNode): IPrizeStructure {
    return {
      stakes: []
    };
  }
}

class DefaultCatchUpData extends CatchUpData {
  private prizeData: DefaultPrizeData;

  constructor(node: IXmlNode) {
    super(node);
  }

  protected getPrizeStructure(node: IXmlNode): IPrizeStructure {
    if (!this.prizeData) {
      this.prizeData = new DefaultPrizeData(node);
    }
    return this.prizeData.prizeStructure;
  }
}

class DefaultResetData extends ResetData {
  private prizeData: DefaultPrizeData;

  constructor(node: IXmlNode) {
    super(node);
  }

  protected getPrizeStructure(node: IXmlNode): IPrizeStructure {
    if (!this.prizeData) {
      this.prizeData = new DefaultPrizeData(node);
    }
    return this.prizeData.prizeStructure;
  }
}

class DefaultCallsData extends CallsData {
  constructor(node: IXmlNode) {
    super(node);
  }
}

class DefaultNextGameData extends NextGameData {
  private prizeData: DefaultPrizeData;

  constructor(node: IXmlNode) {
    super(node);
  }

  protected getPrizeStructure(node: IXmlNode): IPrizeStructure {
    if (!this.prizeData) {
      this.prizeData = new DefaultPrizeData(node);
    }
    return this.prizeData.prizeStructure;
  }
}

class DefaultBoxNumbers extends BoxNumbersData {
  constructor(node: IXmlNode){
    super(node);
  }
}

export {
  DefaultCatchUpData,
  DefaultResetData,
  DefaultCallsData,
  DefaultNextGameData,
  DefaultBoxNumbers
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_default/_domain/models/prize.ts